<script setup>
const props = defineProps(["faqs"]);

import { ref, onMounted } from "vue";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { prefersReducedMotion } from "@utils/prefersReducedMotion";
import ChevronUp from "@/components/icons/ChevronUp.vue";
import TransitionExpand from "@/components/transitions/TransitionExpand.vue";

const activeFaq = ref(null);

const heading = ref(null);
const faqsList = ref(null);

const toggleFaq = (faq) => {
	activeFaq.value = activeFaq.value === faq ? null : faq;
};

onMounted(() => {
	if (prefersReducedMotion()) return;

	gsap.registerPlugin(ScrollTrigger);

	gsap.from(heading.value, {
		opacity: 0,
		y: 24,
		duration: 0.5,
		ease: "power2.inOut",
		scrollTrigger: {
			trigger: heading.value,
			start: "top 90%",
			end: "bottom 20%",
		},
	});

	gsap.from(faqsList.value, {
		opacity: 0,
		y: 24,
		duration: 0.5,
		delay: 0.1,
		ease: "power2.inOut",
		scrollTrigger: {
			trigger: faqsList.value,
			start: "top 90%",
			end: "bottom 20%",
		},
	});
});
</script>

<template>
	<section class="pb-64 md:py-120">
		<div class="container">
			<div class="grid grid-cols-12 gap-y-48">
				<div class="col-span-12 lg:col-span-6">
					<h2 class="h4 font-primary-condensed lg:max-w-150" ref="heading">
						Frequently Asked Questions
					</h2>
				</div>
				<ul
					class="col-span-12 flex flex-col gap-24 lg:col-span-6 lg:gap-32"
					ref="faqsList"
				>
					<li
						class="w-full border-b border-[var(--theme-surface)]/10 pb-24 lg:pb-32"
						v-for="faq in faqs"
						:key="faq.question"
					>
						<button
							class="flex w-full items-center justify-between"
							@click="toggleFaq(faq)"
						>
							<h3 class="h8 font-primary-condensed">
								{{ faq.question }}
							</h3>
							<div
								class="shrink-0 transition-transform duration-500"
								:class="{ 'rotate-180': activeFaq === faq }"
							>
								<ChevronUp />
							</div>
						</button>
						<TransitionExpand>
							<div v-if="activeFaq === faq">
								<div class="pt-20">
									<p>{{ faq.answer }}</p>
								</div>
							</div>
						</TransitionExpand>
					</li>
				</ul>
			</div>
		</div>
	</section>
</template>
